import BelowNavbar from '../CommonPage/BelowNavbar';
import "../CommonPage/Navbar.css";
import UpperNavbar from '../CommonPage/UpperNavbar';

const Navbar = () => {
  return (
    <>
    <header className='navbar-white fixed-top bg-white'>
        <UpperNavbar />
        <BelowNavbar />
    </header>
    </>
  )
}

export default Navbar;